import { WSQueryConfig } from "@ws-react-query";
import {
  ApiQueryListBulkPayrollBatches,
  listBulkPayrollBatches
} from "../../../services/bulkPayrollBatch";
import { WSServiceError } from "../../../utils/serviceHelper";
import { useWSQuery } from "../../helpers";

export const QUERY_BULK_PAYROLL_BATCHES = "QUERY_BULK_PAYROLL_BATCHES";

export const useQueryBulkPayrollBatches = (
  query?: ApiQueryListBulkPayrollBatches,
  config?: WSQueryConfig<
    Awaited<ReturnType<typeof listBulkPayrollBatches>>,
    WSServiceError
  >
) =>
  useWSQuery(
    [QUERY_BULK_PAYROLL_BATCHES, query],
    () => listBulkPayrollBatches(query),
    config
  );
